import React from "react";
import Div100vh from "react-div-100vh/lib/Div100vh";
import { properties } from "../../../helpers/actions/Action";
import TopNavbar from "../../topNavbar/TopNavbar";

const PowerpointPage = (props) => {
  // const linkToPPTFile =
  //   "https://anglianwater-my.sharepoint.com/:p:/g/personal/rmorris4_anglianwater_co_uk/EWOpre-2Vo9CvFvp5iTcCEsBwkxMvrxGZx4Zgug0ejP-_g?e=MRGIZX";

  return (
    <div style={{ overflowY: "auto" }}>
      <Div100vh>
        <TopNavbar />
        {/* <PageHeader src="/water-bg.jpeg" alt="water-bg"></PageHeader> */}
        {/* <TrainingPageSummary name={this.props.user.name} /> */}
        {/* <br /> */}
        {/* {console.log("props.pvurl in powerpoint =", props.pvUrl)} */}
        <div
          style={{
            textAlign: "center",
            marginTop: "25px",
            marginBottom: "25px",
            height: "100%",
          }}
        >
          <iframe
            src={props.pvUrl}
            width="476px"
            height="288px"
            frameborder="0"
          ></iframe>
        </div>
      </Div100vh>
    </div>
  );
};

export default PowerpointPage;
